module.exports = __webpack_public_path__ + "img/logo-malaysia.c633c7d1.png";